import React from "react";
import styles from "./PreviewHistoryList.module.scss";
import { map } from "lodash";
import { PreviewHistoryListBloc, PreviewHistoryListBlocState } from "./PreviewHistoryListBloc";
import { usePreviewAppStore } from "@custom-hooks/HomeUsePluginRoot/usePreviewAppStore";

import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import { useCreation } from "ahooks";
import { PreviewHistoryListItem } from "./PreviewHistoryListItem";
import { PreviewAdd } from "./PreviewAdd";

export interface PreviewHistoryListProps {
  selectPreview: (previewData: PreviewApp.UISaasValueType) => void;
  createNewPreview: () => void;
}

export function PreviewHistoryList(props: PreviewHistoryListProps) {
  const { previewAppList } = usePreviewAppStore();

  const state = new PreviewHistoryListBlocState();
  const bloc = useCreation(() => new PreviewHistoryListBloc(state), []);

  function onQrcodeBoxClick(event: React.MouseEvent<HTMLDivElement>) {
    event.preventDefault();
    event.stopPropagation();
  }

  return (
    <div>
      {map(previewAppList, (item, index) => {
        return (
          <PreviewHistoryListItem
            item={item}
            key={`${item.title} - ${index}`}
            selectPreview={props.selectPreview}
            handleCopyLink={(link, uuid) => bloc.handleCopyLink(link, uuid)}
            handleQrcode={link => bloc.handleGenQrcode(link, item.v2App?.appName ?? item.title)}
            isCodeLodaing={bloc.state.isCodeLodaing.value}
          />
        );
      })}

      <PreviewAdd createNewPreview={props.createNewPreview} />

      {/* display qrcode */}
      {bloc.state.isQrcodeBox.value && (
        <div className={styles.qrcodeModeBox} onClick={e => onQrcodeBoxClick(e)} data-testid="QRCodeMode">
          <div onClick={() => bloc.handleQrcodeClose()} className={styles.maskBox}></div>

          <div className={styles.qrcodeBox}>
            <div className={styles.codeTitle}>{bloc.state.titleStr.value}</div>
            <img
              className={styles.crossBox}
              onClick={() => bloc.handleQrcodeClose()}
              src={`${settings.S3CDN}${settings.viewAssetsPath}ACAEB5Cross.svg`}
              width="20"
              alt="icon"
            />
            <img className={styles.codeBox} src={bloc.state.qrCodeUrl.value} width="240" alt="icon" />
            <div className={styles.codeText}>Preview on mobile device</div>
          </div>
        </div>
      )}
    </div>
  );
}
